export default {
  id: null,
  nameGroup: null,
  usuarioGroupId: [],
  inative: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/groupmodel.js